import React from 'react';
import { Cpu, CheckCircle } from '@phosphor-icons/react';
import { loadingSteps } from './constants';

export const AILoadingSequence = ({ currentStep, progress }) => {
  return (
    <div className="bg-neutral-900 dark:bg-black border-2 border-black dark:border-white p-6 font-mono text-sm" data-testid="ai-loading-sequence">
      <div className="flex items-center gap-2 mb-4 text-[#2B4C6F]">
        <Cpu size={20} weight="bold" className="animate-pulse" />
        <span className="uppercase tracking-widest text-xs">AI PROCESSING</span>
      </div>
      
      <div className="space-y-2">
        {loadingSteps.map((step, index) => {
          const StepIcon = step.icon;
          const isActive = index === currentStep;
          const isComplete = index < currentStep;
          
          return (
            <div 
              key={step.id}
              className={`flex items-center gap-3 py-2 px-3 transition-all duration-300 ${
                isActive ? 'bg-[#2B4C6F]/20 text-white' : 
                isComplete ? 'text-emerald-400' : 'text-neutral-600'
              }`}
            >
              <div className="w-5 flex-shrink-0">
                {isComplete ? (
                  <CheckCircle size={18} weight="fill" className="text-emerald-400" />
                ) : isActive ? (
                  <StepIcon size={18} weight="bold" className="animate-pulse" />
                ) : (
                  <span className="text-neutral-600">○</span>
                )}
              </div>
              <span className={`uppercase tracking-wide text-xs ${isActive ? 'font-bold' : ''}`}>
                {step.label}
              </span>
              {isActive && (
                <span className="ml-auto text-[#2B4C6F] animate-pulse">...</span>
              )}
            </div>
          );
        })}
      </div>
      
      <div className="mt-6 h-1 bg-neutral-800 overflow-hidden">
        <div 
          className="h-full bg-[#2B4C6F] transition-all duration-300 ease-out"
          style={{ width: `${progress}%` }}
        />
      </div>
      <p className="mt-2 text-neutral-500 text-xs uppercase tracking-widest text-center">
        {Math.round(progress)}% COMPLETE
      </p>
    </div>
  );
};
